/* searchtoggle */
$(function() {
    const searchToggle = $('.searchToggleTrigger');
    const searchBar = $('.searchBarElement');
    const searchBarFocusElement = $('.searchBarFocus');
    const wrapper = $('.header');
    let searchBarHidden = true;
    const searchClose = $('.searchToggleClose');

    searchToggle.click(function(event) {
        event.preventDefault();
        searchBarHidden = !searchBarHidden;
        $(this).toggleClass('__active');
        wrapper.toggleClass('__searchactive');
        searchBar.attr('aria-hidden',searchBarHidden);
        if (searchBarHidden) {
            searchBar.find('*[tabindex=0]').attr('tabindex', '-1');
            searchToggle.focus();
        } else {
            searchBar.find('*[tabindex=-1]').attr('tabindex', '0');
            searchBarFocusElement.focus();
        }
    });

    searchClose.click(function(event) {
        event.preventDefault();
        wrapper.removeClass('__searchactive');
        searchBar.attr('aria-hidden', false);
        searchToggle.removeClass('__active');
    });       
    
});
